
export default "/assets/h1-micro.49158d58.svg"